import { Component, Input } from '@angular/core';

@Component({
  selector: 'axis-scroll-container',
  templateUrl: './scroll-container.component.html'
})
export class ScrollContainerComponent {
 @Input() border = false;
 @Input() scrollHeight = '';
  constructor() { }
}
